import type { AdminInitiativeLead } from '../api/admin';
import type { KeyActivity, Objective } from '../types/milestones';
import { subawardeeMatchesLeadPortfolio } from './initiativeLeadUtils';

function collectRawSubawardeeNames(keyActivity: KeyActivity): string[] {
  const names: string[] = [];
  if (keyActivity.subawardee?.trim()) names.push(keyActivity.subawardee.trim());
  for (const name of keyActivity.subawardees ?? []) {
    if (name.trim()) names.push(name.trim());
  }
  for (const goal of keyActivity.goals) {
    for (const activity of goal.activities) {
      for (const milestone of activity.milestones) {
        if (milestone.subawardee?.trim()) names.push(milestone.subawardee.trim());
      }
    }
  }
  return names;
}

export function keyActivityMatchesLeadSubawardees(
  keyActivity: KeyActivity,
  leadSubawardees: string[]
): boolean {
  const names = collectRawSubawardeeNames(keyActivity);
  if (names.length === 0) return false;
  return names.some((name) => subawardeeMatchesLeadPortfolio(name, leadSubawardees));
}

export function filterObjectivesByInitiativeLead(
  objectives: Objective[],
  leadSubawardees: string[]
): Objective[] {
  if (leadSubawardees.length === 0) return objectives;

  return objectives
    .map((objective) => ({
      ...objective,
      key_activities: objective.key_activities.filter((ka) =>
        keyActivityMatchesLeadSubawardees(ka, leadSubawardees)
      ),
    }))
    .filter((objective) => objective.key_activities.length > 0);
}

export function applyInitiativeLeadFilter(
  objectives: Objective[],
  initiativeLeadId: string | null,
  leads: AdminInitiativeLead[],
  options: { view: 'component' | 'subawardee'; subawardee: string | null }
): Objective[] {
  if (!initiativeLeadId) return objectives;

  const lead = leads.find((l) => l.id === initiativeLeadId);
  if (!lead) return objectives;

  const leadSubawardees = lead.subawardees;

  if (options.view === 'subawardee') {
    if (options.subawardee) {
      if (!subawardeeMatchesLeadPortfolio(options.subawardee, leadSubawardees)) {
        return [];
      }
      return objectives;
    }
    return filterObjectivesByInitiativeLead(objectives, leadSubawardees);
  }

  return filterObjectivesByInitiativeLead(objectives, leadSubawardees);
}
